import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "24px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  pageTitle: {
    fontSize: "20px !important",
    fontWeight: "700 !important",
    color: "#1e293b",
    fontFamily: "'Inter', sans-serif !important",
  },
  breadcrumb: {
    fontSize: "14px !important",
    color: "#64748b",
    fontFamily: "'Inter', sans-serif !important",
    "& span": {
      fontWeight: "600",
      color: "#1e293b",
    },
  },
  actionRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "16px",
  },
  searchWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #e2e8f0",
    borderRadius: "100px",
    padding: "6px 16px",
    width: "320px",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "&:focus-within": {
      borderColor: "#94a3b8",
    },
  },
  searchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    marginLeft: "8px",
    fontSize: "14px",
    color: "#334155",
    "&::placeholder": {
      color: "#94a3b8",
    },
  },
  searchIcon: {
    color: "#94a3b8",
    fontSize: "20px",
  },
  rightActions: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  addButton: {
    backgroundColor: "#1e1e1e !important",
    color: "#ffffff !important",
    borderRadius: "8px !important",
    padding: "10px 20px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1) !important",
    "&:hover": {
      backgroundColor: "#2e2e2e !important",
    },
  },
  tableWrapper: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #f1f5f9",
  },
  tableHeaderRow: {
    backgroundColor: "#f8fafc",
  },
  tableHeaderCell: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    color: "#475569 !important",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "'Inter', sans-serif !important",
    borderBottom: "1px solid #f1f5f9 !important",
  },
  tableRow: {
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  tableCell: {
    fontSize: "14px !important",
    color: "#334155 !important",
    fontFamily: "'Inter', sans-serif !important",
    borderBottom: "1px solid #f1f5f9 !important",
  },
  boldText: {
    fontWeight: "700 !important",
    color: "#0f172a !important",
  },
  statusActive: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "20px",
    backgroundColor: "#dcfce7",
    color: "#166534",
    fontSize: "12px",
    fontWeight: "600",
  },
  statusInactive: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "20px",
    backgroundColor: "#fee2e2",
    color: "#991b1b",
    fontSize: "12px",
    fontWeight: "600",
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    color: "#64748b",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    marginRight: "16px",
    transition: "color 0.2s",
    "&:hover": {
      color: "#1e293b",
    },
  },
  actionDeleteButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    color: "#64748b",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    transition: "color 0.2s",
    "&:hover": {
      color: "#dc2626",
    },
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    backgroundColor: "#ffffff",
    borderTop: "1px solid #f1f5f9",
    fontFamily: "'Inter', sans-serif",
  },
  paginationText: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: "500",
  },
  paginationControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  pageButton: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    color: "#475569 !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#f1f5f9 !important",
    },
  },
  pageButtonActive: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#ffffff !important",
    backgroundColor: "#1e1e1e !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#2e2e2e !important",
    },
  },
  pageDots: {
    padding: "0 4px",
    color: "#94a3b8",
    fontSize: "14px",
    fontWeight: "500",
    userSelect: "none",
  },
  pageArrow: {
    color: "#64748b",
    cursor: "pointer",
    transition: "color 0.2s",
    "&:hover": {
      color: "#0f172a",
    },
    "&.disabled": {
      color: "#cbd5e1",
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  },
}));

export default useStyles;
